// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/big-logo-common-grey.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wrapper_bg__Lxs\\+A {
  width: 100vw;
  height: 100vh;
  background: #f5f5fe url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center bottom no-repeat;
  background-size: cover;
  overflow-x: hidden;
  overflow-y: scroll;
}
.Wrapper_bg__Lxs\\+A h1 {
  font-size: 28px;
  font-weight: 400;
  color: #00007a;
  line-height: 48px;
  margin-bottom: 20px !important;
}
.Wrapper_bg__Lxs\\+A b {
  font-weight: 500;
}
.Wrapper_bg__Lxs\\+A ul {
  padding-left: 0;
}
.Wrapper_bg__Lxs\\+A p {
  font-size: 16px;
  font-weight: 300;
  color: #00007a;
  line-height: 28px;
}
.Wrapper_bg__Lxs\\+A button {
  width: 121px;
  height: 40px;
  border-radius: 4px !important;
  margin-top: 40px;
}

.Wrapper_cobranding__3FKrG {
  color: #838390;
}
.Wrapper_cobranding__3FKrG > svg {
  display: block;
  margin-top: -12px;
  margin-left: 28px;
}
.Wrapper_cobranding__3FKrG > svg path {
  fill: #838390 !important;
}

.Wrapper_content__vVsio {
  width: calc(100vw - 486px);
  height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 46px;
}
.Wrapper_content__vVsio > div {
  width: 500px;
  padding-bottom: 20px;
}
.Wrapper_content__vVsio form > div:not(:first-child) {
  margin-top: 20px;
}
.Wrapper_content__vVsio button {
  float: right;
}
.Wrapper_content__vVsio button svg {
  vertical-align: middle;
  margin-left: 8px;
}
.Wrapper_content__vVsio button svg path {
  fill: #FFFFFF;
}
.Wrapper_content__vVsio.Wrapper_previousPage__X1v7x {
  animation: Wrapper_return__nX5sE ease-in 0.5s;
}
.Wrapper_content__vVsio.Wrapper_nextPage__8N8Gl {
  animation: Wrapper_next__g7\\+Wr ease-in 0.5s;
}

.Wrapper_singleBloc__giT1r {
  margin: auto;
}
.Wrapper_singleBloc__giT1r > div {
  margin: auto;
}

.Wrapper_estimate__tQ3Ga {
  width: 100%;
  height: auto;
  margin: 60px 0;
}
.Wrapper_estimate__tQ3Ga > div {
  width: 100%;
  max-width: 1064px;
  margin: 0 auto;
}

.Wrapper_back__ik1UU {
  display: block;
  cursor: pointer;
  color: #0000c9;
  font-weight: 300;
  margin-bottom: 30px;
}
.Wrapper_back__ik1UU svg {
  transform: rotate(-90deg);
  vertical-align: top;
}

.Wrapper_chat__b6uqo {
  width: 348px;
  position: fixed;
  right: 46px;
  bottom: 100px;
}
.Wrapper_chat__b6uqo li {
  padding: 20px;
  margin-top: 12px;
  border-radius: 12px;
  background-color: #FFFFFF;
  list-style-type: none;
  opacity: 0.1;
}
.Wrapper_chat__b6uqo li:last-child {
  opacity: 1;
}
.Wrapper_chat__b6uqo li header {
  color: #00007a;
  font-weight: 500;
  margin-bottom: 5px;
}
.Wrapper_chat__b6uqo li header:before {
  content: "i";
  border-radius: 50%;
  color: #FFFFFF;
  text-align: center;
  font-size: 12px;
  background-color: #00007a;
  width: 17px;
  height: 17px;
  line-height: 17px;
  display: inline-block;
  margin-right: 10px;
}
.Wrapper_chat__b6uqo li p {
  font-size: 14px;
  line-height: 24px;
}
.Wrapper_chat__b6uqo.Wrapper_previousPage__X1v7x {
  animation: Wrapper_return__nX5sE ease-in 0.5s;
}
.Wrapper_chat__b6uqo.Wrapper_nextPage__8N8Gl {
  animation: Wrapper_next__g7\\+Wr ease-in 0.5s;
}

@keyframes Wrapper_return__nX5sE {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  50% {
    opacity: 0;
    transform: translateY(50vh);
  }
  51% {
    opacity: 0;
    transform: translateY(-50vh);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes Wrapper_next__g7\\+Wr {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  50% {
    opacity: 0;
    transform: translateY(-50vh);
  }
  51% {
    opacity: 0;
    transform: translateY(50vh);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@media screen and (max-width: 986px) {
  .Wrapper_content__vVsio {
    width: 100vw;
    height: auto;
    margin: 0;
    margin-top: 60px;
    transform: none;
  }
  .Wrapper_chat__b6uqo {
    position: initial;
    width: 100vw;
    max-width: 592px;
    padding: 0 46px;
    margin: 0 auto;
  }
  .Wrapper_chat__b6uqo li:not(:last-child) {
    display: none;
  }
}
@media screen and (max-width: 600px) {
  .Wrapper_content__vVsio {
    margin-top: 50px;
  }
  .Wrapper_content__vVsio > div {
    margin: 0 20px;
  }
  .Wrapper_chat__b6uqo {
    max-width: 540px;
    padding: 0 20px;
  }
}
@media screen and (min-width: 1400px) {
  .Wrapper_content__vVsio {
    width: 100vw;
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/Wrapper/Wrapper.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,YAAA;EACA,aAAA;EACA,mFAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAIJ;AAFI;EACI,eAAA;EACA,gBAAA;EACA,cCPG;EDQH,iBAAA;EACA,8BAAA;AAIR;AADI;EACI,gBAAA;AAGR;AAAI;EACI,eAAA;AAER;AACI;EACI,eAAA;EACA,gBAAA;EACA,cCvBG;EDwBH,iBAAA;AACR;AAEI;EACI,YAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;AAAR;;AAIA;EACI,cC3BO;AD0BX;AAGI;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AADR;AAGQ;EACI,wBAAA;AADZ;;AAMA;EACI,0BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHJ;AAKI;EACI,YAAA;EACA,oBAAA;AAHR;AAOQ;EACI,gBAAA;AALZ;AASI;EACI,YAAA;AAPR;AASQ;EACI,sBAAA;EACA,gBAAA;AAPZ;AASY;EACI,aAAA;AAPhB;AAYI;EACI,6CAAA;AAVR;AAaI;EACI,4CAAA;AAXR;;AAeA;EACI,YAAA;AAZJ;AAcI;EACI,YAAA;AAZR;;AAgBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAbJ;AAeI;EACI,WAAA;EACA,iBAAA;EACA,cAAA;AAbR;;AAiBA;EACI,cAAA;EACA,eAAA;EACA,cCnHO;EDoHP,gBAAA;EACA,mBAAA;AAdJ;AAgBI;EACI,yBAAA;EACA,mBAAA;AAdR;;AAkBA;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;AAfJ;AAiBI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAfR;AAiBQ;EACI,UAAA;AAfZ;AAkBQ;EACI,cC9ID;ED+IC,gBAAA;EACA,kBAAA;AAhBZ;AAkBY;EACI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBCxJL;EDyJK,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AAhBhB;AAoBQ;EACI,eAAA;EACA,iBAAA;AAlBZ;AAsBI;EACI,6CAAA;AApBR;AAuBI;EACI,4CAAA;AArBR;;AA8BA;EACI;IACI,UAAA;IACA,wBAAA;EA3BN;EA6BE;IACI,UAAA;IACA,2BAAA;EA3BN;EA6BE;IACI,UAAA;IACA,4BAAA;EA3BN;EA6BE;IACI,UAAA;IACA,wBAAA;EA3BN;AACF;AA8BA;EACI;IACI,UAAA;IACA,wBAAA;EA5BN;EA8BE;IACI,UAAA;IACA,4BAAA;EA5BN;EA8BE;IACI,UAAA;IACA,2BAAA;EA5BN;EA8BE;IACI,UAAA;IACA,wBAAA;EA5BN;AACF;AAkCA;EACI;IACI,YAAA;IACA,YAAA;IACA,SAAA;IACA,gBAAA;IACA,eAAA;EAhCN;EAkCE;IACI,iBAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;IACA,cAAA;EAhCN;EAkCM;IACI,aAAA;EAhCV;AACF;AAoCA;EACI;IACI,gBAAA;EAlCN;EAoCM;IACI,cAAA;EAlCV;EAqCE;IACI,gBAAA;IACA,eAAA;EAnCN;AACF;AAsCA;EACI;IACI,YAAA;IACA,cAAA;EApCN;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.bg{\n    width: 100vw;\n    height: 100vh;\n    background: #f5f5fe url(../../../assets/big-logo-common-grey.svg) center bottom no-repeat;\n    background-size: cover;\n    overflow-x: hidden;\n    overflow-y: scroll;\n\n    h1{\n        font-size: 28px;\n        font-weight: 400;\n        color: colors.$primary8;\n        line-height: 48px;\n        margin-bottom: 20px!important;\n    }\n    \n    b{\n        font-weight: 500;\n    }\n    \n    ul{\n        padding-left: 0;\n    }\n    \n    p{\n        font-size: 16px;\n        font-weight: 300;\n        color: colors.$primary8;\n        line-height: 28px;\n    }\n    \n    button{\n        width: 121px;\n        height: 40px;\n        border-radius: 4px!important;\n        margin-top: 40px;\n    }\n}\n\n.cobranding{\n    color: colors.$neutral8;\n\n    > svg {\n        display: block;\n        margin-top: -12px;\n        margin-left: 28px;\n\n        path{\n            fill: colors.$neutral8!important;\n        }\n    }\n}\n\n.content{\n    width: calc(100vw - 486px);\n    height: calc(100vh - 120px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 46px;\n\n    > div {\n        width: 500px;\n        padding-bottom: 20px;\n    }\n\n    form{\n        > div:not(:first-child) {\n            margin-top: 20px;\n        }\n    }\n\n    button{\n        float: right;\n\n        svg{\n            vertical-align: middle;\n            margin-left: 8px;\n\n            path{\n                fill: #FFFFFF;\n            }\n        }\n    }\n\n    &.previousPage{\n        animation: return ease-in 0.5s;\n    }\n\n    &.nextPage{\n        animation: next ease-in 0.5s;\n    }\n}\n\n.singleBloc{\n    margin: auto;\n\n    > div{\n        margin: auto;\n    }\n}\n\n.estimate{\n    width: 100%;\n    height: auto;\n    margin: 60px 0;\n\n    > div {\n        width: 100%;\n        max-width: 1064px;\n        margin: 0 auto;\n    }\n}\n\n.back{\n    display: block;\n    cursor: pointer;\n    color: colors.$primary6;\n    font-weight: 300;\n    margin-bottom: 30px;\n\n    svg{\n        transform: rotate(-90deg);\n        vertical-align: top;\n    }\n}\n\n.chat{\n    width: 348px;\n    position: fixed;\n    right: 46px;\n    bottom: 100px;\n\n    li{\n        padding: 20px;\n        margin-top: 12px;\n        border-radius: 12px;\n        background-color: #FFFFFF;\n        list-style-type: none;\n        opacity: 0.1;\n\n        &:last-child{\n            opacity: 1;\n        }\n\n        header{\n            color: colors.$primary8;\n            font-weight: 500;\n            margin-bottom: 5px;\n\n            &:before{\n                content: 'i';\n                border-radius: 50%;\n                color: #FFFFFF;\n                text-align: center;\n                font-size: 12px;\n                background-color: colors.$primary8;\n                width: 17px;\n                height: 17px;\n                line-height: 17px;\n                display: inline-block;\n                margin-right: 10px;\n            }\n        }\n\n        p{\n            font-size: 14px;\n            line-height: 24px;\n        }\n    }\n\n    &.previousPage{\n        animation: return ease-in 0.5s;\n    }\n\n    &.nextPage{\n        animation: next ease-in 0.5s;\n    }\n}\n\n\n\n\n// Animations\n\n@keyframes return {\n    0%{\n        opacity: 1;\n        transform: translateY(0);\n    }\n    50% {\n        opacity: 0;\n        transform: translateY(50vh);\n    }\n    51%{\n        opacity: 0;\n        transform: translateY(-50vh);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes next {\n    0%{\n        opacity: 1;\n        transform: translateY(0);\n    }\n    50% {\n        opacity: 0;\n        transform: translateY(-50vh);\n    }\n    51%{\n        opacity: 0;\n        transform: translateY(50vh);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n// Responsive\n\n@media screen and (max-width: 986px) {\n    .content{\n        width: 100vw;\n        height: auto;\n        margin: 0;\n        margin-top: 60px;\n        transform: none;\n    }\n    .chat{\n        position: initial;\n        width: 100vw;\n        max-width: 592px;\n        padding: 0 46px;\n        margin: 0 auto;\n\n        li:not(:last-child){\n            display: none;\n        }\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .content{\n        margin-top: 50px;\n\n        > div{\n            margin: 0 20px;\n        }\n    }\n    .chat{\n        max-width: 540px;\n        padding: 0 20px;\n    }\n}\n\n@media screen and (min-width: 1400px) {\n    .content{\n        width: 100vw;\n        margin-left: 0;\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"bg": `Wrapper_bg__Lxs+A`,
	"cobranding": `Wrapper_cobranding__3FKrG`,
	"content": `Wrapper_content__vVsio`,
	"previousPage": `Wrapper_previousPage__X1v7x`,
	"return": `Wrapper_return__nX5sE`,
	"nextPage": `Wrapper_nextPage__8N8Gl`,
	"next": `Wrapper_next__g7+Wr`,
	"singleBloc": `Wrapper_singleBloc__giT1r`,
	"estimate": `Wrapper_estimate__tQ3Ga`,
	"back": `Wrapper_back__ik1UU`,
	"chat": `Wrapper_chat__b6uqo`
};
export default ___CSS_LOADER_EXPORT___;
